import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TAppService } from '@core/services/t-app.service';
import { environment } from '@environments/environment';

import { Subscription } from 'rxjs';
import * as dayjs from 'dayjs';
import { GtmService } from '@core/services/gtm.service';
@Component({
  selector: 'app-t-header',
  templateUrl: './t-header.component.html',
  styleUrls: ['./t-header.component.scss'],
})
export class THeaderComponent implements OnInit, OnDestroy {
  isViewProducts = true;
  isViewTHeader = true;
  isViewNotice = true;
  isTapp = false;

  isLogin = true;
  noticeItems = [];
  queryParamsSubscription: Subscription;

  commonResourcesPath = environment.commonResourcesPath;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private domSanitizer: DomSanitizer,
    private tAppService: TAppService,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.queryParamsSubscription = this.activatedRoute.url.subscribe(() => {
      const isTop = this.router.url.match(/^\/top/) !== null;

      if (this.tAppService.isTappAndVersionCheck(3, 5, 0)) {
        //新T
        this.isViewTHeader = false;
        this.isViewProducts = false;
        this.isTapp = true;
        if (!isTop) {
          this.isViewNotice = false;
        }
      } else if (this.tAppService.isTapp()) {
        //旧T
        this.isViewTHeader = false;
        this.isViewProducts = true;
        this.isTapp = true;
      }
    });

    this.setNoticeItem();
    this.setIsLogin();
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  onClickMenu() {
    document.body
      .querySelector('.t-header__main__sp-menu--img.open')
      ?.classList.toggle('show');
    document.body
      .querySelector('.t-header__main__sp-menu--img.close')
      ?.classList.toggle('show');

    document.body
      .querySelector('.t-header__main__sp-menu-item')
      ?.classList.remove('hide');
    document.body
      .querySelector('.t-header__main__sp-menu-overlay')
      ?.classList.remove('hide');
    document.body
      .querySelector('.t-header__main__sp-menu-overlay')
      ?.classList.toggle('show');
    document.body
      .querySelector('.t-header__main__sp-menu-item')
      ?.classList.toggle('show');
  }

  getHtml(html: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

  onClickEvent(name: string) {
    this.gtmService.sendEventSetCategory('common', 'header', name);
  }

  private setNoticeItem() {
    this.JSONP(
      environment.maintenanceJson + `?_=${new Date().getTime()}`,
      '__maintenance_info'
    ).then((data: any[]) => {
      const check = (array: any[]) =>
        array
          .sort((a, b) => dayjs(b.start).unix() - dayjs(a.start).unix())
          .filter(
            (v) =>
              dayjs(v.start).unix() < dayjs().unix() &&
              dayjs().unix() < dayjs(v.end).unix()
          );

      const allNotice: any[] = data['000'] ? data['000'].info : [];
      const kujiNotice: any[] = data['002'] ? data['002'].info : [];
      const item = []
        .concat(check(allNotice))
        .concat(check(kujiNotice))
        .slice(0, 5);
      this.noticeItems = item;
    });
  }

  private setIsLogin() {
    const SID = document.cookie
      .split('; ')
      .find((row) => row.startsWith('SID'));
    this.isLogin = SID !== undefined;
  }

  private JSONP(url, cbName = 'callback') {
    return new Promise(function (_r, _e) {
      window[cbName] = function (j) {
        delete window[cbName];
        _r(j);
      };
      var s = document.createElement('script');
      s.src = url;
      document.head.appendChild(s);
      s.onerror = function (e) {
        delete window[cbName];
        _e(e);
        s.remove();
      };
    });
  }
}
